import Modal from 'utils/packages/Modal';
import { formatDayMonth } from 'utils/formatting';
const strings = {
    title: 'Past budgets can’t be changed',
    subtitle: (currentPeriod, isRollover) => `Changes you make now apply to the current period (${currentPeriod}) and the ones after it.${isRollover
        ? ' The amount already rolled into this period stays the same.'
        : ''}`,
    cancel: 'Cancel',
    confirm: 'Edit current budget',
};
/**
 * Edits only ever apply to the current period, so the budgeting screens show
 * this before opening the edit options from a past one.
 */
export const showPastPeriodSheet = (currentPeriod, isRollover, onEditCurrentBudget) => {
    Modal.showConfirmation({
        title: strings.title,
        subtitle: strings.subtitle(`${formatDayMonth(currentPeriod.from)} – ${formatDayMonth(currentPeriod.to)}`, isRollover),
        // The confirmation modal draws its confirm button as the light top one
        // and its cancel button as the main bottom one. The design has Cancel on
        // top and Edit current budget as the main action, so the two slots are
        // swapped
        confirmButtonTitle: strings.cancel,
        cancelButtonTitle: strings.confirm,
        onPressCancel: onEditCurrentBudget,
    });
};
